import { render } from "./BaseRadioGroup.vue?vue&type=template&id=b8853f10"
import script from "./BaseRadioGroup.vue?vue&type=script&lang=js"
export * from "./BaseRadioGroup.vue?vue&type=script&lang=js"
script.render = render

export default script